export const browserLocale =
  navigator.language || navigator.languages[0] || "en-US"
export const dateFormat = browserLocale.toLowerCase().includes("us")
  ? "MM/DD/YYYY"
  : "D/M/YYYY"

  export const formatDateFromIsoStringToDateAsDDabrMMYYYY = (
    dateString: string,
  ): string => {
    if (dateString) {
      const monthAb = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ]
      const dateParts = dateString.split("T")[0].split("-")
      return `${String(
        dateParts[2] 
      )} ${monthAb[Number(dateParts[1]) - 1]} ${Number(dateParts[0])}`
    }
    return ""
  }